import React, { lazy, Suspense, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import ErrorPage from './common/components/ErrorPage'
import reportWebVitals from './reportWebVitals'
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom'

window.history.scrollRestoration = 'manual'

function ScrollToTop() {
  const { pathname } = useLocation()
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])
  return <Outlet />
}

const Classic = lazy(() => import('./classic/index'))
const Game = lazy(() => import('./game/index'))
const Home = lazy(() => import('./game/components/Home'))
const OurStory = lazy(() => import('./game/components/OurStory'))
const TravelStay = lazy(() => import('./game/components/TravelStay'))
const Registry = lazy(() => import('./game/components/Registry'))
const Schedule = lazy(() => import('./game/components/Schedule'))
const FAQ = lazy(() => import('./game/components/FAQ'))
const Cryptic = lazy(() => import('./cryptic/index'))
const Admin = lazy(() => import('./admin/index'))
const BabyShowerHub = lazy(() => import('./baby-shower/index'))
const KissesJar = lazy(() => import('./baby-shower/components/KissesJar'))
const BabyPhotos = lazy(() => import('./baby-shower/components/BabyPhotos'))
const MomDadQuiz = lazy(() => import('./baby-shower/components/MomDadQuiz'))
const MeasureBelly = lazy(() => import('./baby-shower/components/MeasureBelly'))

const router = createBrowserRouter([
  {
    element: <ScrollToTop />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <BabyShowerHub /> },
      { path: 'classic', element: <Classic /> },
      { path: 'baby-shower', element: <BabyShowerHub /> },
      { path: 'baby-shower/cryptic', element: <Cryptic /> },
      { path: 'baby-shower/kisses', element: <KissesJar /> },
      { path: 'baby-shower/photos', element: <BabyPhotos /> },
      { path: 'baby-shower/mom-dad', element: <MomDadQuiz /> },
      { path: 'baby-shower/measure', element: <MeasureBelly /> },
      { path: 'admin', element: <Admin /> },
      {
        path: 'gamer',
        element: <Game />,
        children: [
          { index: true, element: <Home /> },
          { path: 'our-story', element: <OurStory /> },
          { path: 'travel', element: <TravelStay /> },
          { path: 'registry', element: <Registry /> },
          { path: 'schedule', element: <Schedule /> },
          { path: 'faq', element: <FAQ /> },
        ],
      },
    ],
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
)

reportWebVitals()
